var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgShape8 = function SvgShape8(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 225 225"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "shape-8_svg__cls-1",
    d: "M128.89 29a23.87 23.87 0 0 0 19.46 6.32 23.87 23.87 0 0 1 26.52 19.27 23.87 23.87 0 0 0 12 16.55A23.87 23.87 0 0 1 197 102.27a23.88 23.88 0 0 0 0 20.46 23.87 23.87 0 0 1-10.13 31.18 23.87 23.87 0 0 0-12 16.55 23.87 23.87 0 0 1-26.52 19.27 23.87 23.87 0 0 0-19.46 6.32 23.87 23.87 0 0 1-32.78 0 23.87 23.87 0 0 0-19.46-6.32 23.87 23.87 0 0 1-26.52-19.27 23.87 23.87 0 0 0-12-16.55A23.87 23.87 0 0 1 28 122.73a23.88 23.88 0 0 0 0-20.46 23.87 23.87 0 0 1 10.1-31.18 23.87 23.87 0 0 0 12-16.55 23.87 23.87 0 0 1 26.55-19.27A23.87 23.87 0 0 0 96.11 29a23.87 23.87 0 0 1 32.78 0Z",
    "data-name": "Layer 4"
  })));
};

export default SvgShape8;